/* Amazon-style "Recently viewed" products, stored in localStorage. */
(function () {
  const KEY = 'amazon_recently_viewed';
  const MAX = 12;

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
    } catch (e) {
      /* storage full or unavailable — ignore */
    }
  }

  // Called on product pages via window.amazonTrackProduct(product)
  window.amazonTrackProduct = function (product) {
    if (!product || !product.handle) return;
    let items = read().filter((p) => p.handle !== product.handle);
    items.unshift(product);
    if (items.length > MAX) items = items.slice(0, MAX);
    write(items);
  };

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function render() {
    const mount = document.getElementById('amazon-recently-viewed');
    if (!mount) return;

    const currentHandle = mount.getAttribute('data-current-handle') || '';
    const max = parseInt(mount.getAttribute('data-max'), 10) || MAX;
    const items = read()
      .filter((p) => p.handle !== currentHandle)
      .slice(0, max);

    if (!items.length) {
      mount.closest('.amazon-recent-wrapper')?.setAttribute('hidden', 'hidden');
      return;
    }

    const cards = items
      .map(
        (p) => `
        <a class="amazon-recent__card" href="${escapeHtml(p.url)}">
          <div class="amazon-recent__media">
            ${p.image ? `<img src="${escapeHtml(p.image)}" alt="${escapeHtml(p.title)}" loading="lazy">` : ''}
          </div>
          <div class="amazon-recent__title">${escapeHtml(p.title)}</div>
          <div class="amazon-recent__price">${escapeHtml(p.price)}</div>
        </a>`
      )
      .join('');

    mount.innerHTML = cards;
  }

  if (document.readyState !== 'loading') {
    render();
  } else {
    document.addEventListener('DOMContentLoaded', render);
  }
})();
